import React from 'react'
import {ImportStoreProductHelperTable, SellerStoreProductsTable, StoreProductsTable} from "../components";

export const StoreProductsPage: React.FC = () =>  <StoreProductsTable />;

export const SellerStoreProductsPage: React.FC = () => <SellerStoreProductsTable />;

export const ImportStoreProdujctPage: React.FC = () => <ImportStoreProductHelperTable/>
